import { render, staticRenderFns } from "./AccommodationInfo.vue?vue&type=template&id=d0f705d2&"
import script from "./AccommodationInfo.vue?vue&type=script&lang=js&"
export * from "./AccommodationInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports